import React from "react";
import { StaticImage } from 'gatsby-plugin-image';

const MirtWorkingGroupSection = () => {
  return (
    <div>
      <section>
        <div className="team-mrit">
          <div className="team-mrit-overlay"></div>
          <StaticImage
            className="team-mrit-team-img"
            src="../../../images/team/mrt-team-footer-image.png"
            alt="Theme circles"
            placeholder="none"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
};

export default MirtWorkingGroupSection;